"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const ed5 = require("xmlchars/xml/1.0/ed5");
const ed2 = require("xmlchars/xml/1.1/ed2");
const NSed3 = require("xmlchars/xmlns/1.0/ed3");
var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
const XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
const XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
const rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
const XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
};
// EOC: end-of-chunk
const EOC = -1;
const NL_LIKE = -2;
const S_BEGIN = 0; // Initial state.
const S_BEGIN_WHITESPACE = 1; // leading whitespace
const S_DOCTYPE = 2; // <!DOCTYPE
const S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
const S_DTD = 4; // <!DOCTYPE "//blah" [ ...
const S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
const S_DTD_OPEN_WAKA = 6;
const S_DTD_OPEN_WAKA_BANG = 7;
const S_DTD_COMMENT = 8; // <!--
const S_DTD_COMMENT_ENDING = 9; // <!-- blah -
const S_DTD_COMMENT_ENDED = 10; // <!-- blah --
const S_DTD_PI = 11; // <?
const S_DTD_PI_ENDING = 12; // <?hi "there" ?
const S_TEXT = 13; // general stuff
const S_ENTITY = 14; // &amp and such
const S_OPEN_WAKA = 15; // <
const S_OPEN_WAKA_BANG = 16; // <!...
const S_COMMENT = 17; // <!--
const S_COMMENT_ENDING = 18; // <!-- blah -
const S_COMMENT_ENDED = 19; // <!-- blah --
const S_CDATA = 20; // <![CDATA[ something
const S_CDATA_ENDING = 21; // ]
const S_CDATA_ENDING_2 = 22; // ]]
const S_PI_FIRST_CHAR = 23; // <?hi, first char
const S_PI_REST = 24; // <?hi, rest of the name
const S_PI_BODY = 25; // <?hi there
const S_PI_ENDING = 26; // <?hi "there" ?
const S_XML_DECL_NAME_START = 27; // <?xml
const S_XML_DECL_NAME = 28; // <?xml foo
const S_XML_DECL_EQ = 29; // <?xml foo=
const S_XML_DECL_VALUE_START = 30; // <?xml foo=
const S_XML_DECL_VALUE = 31; // <?xml foo="bar"
const S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
const S_XML_DECL_ENDING = 33; // <?xml ... ?
const S_OPEN_TAG = 34; // <strong
const S_OPEN_TAG_SLASH = 35; // <strong /
const S_ATTRIB = 36; // <a
const S_ATTRIB_NAME = 37; // <a foo
const S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
const S_ATTRIB_VALUE = 39; // <a foo=
const S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
const S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
const S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
const S_CLOSE_TAG = 43; // </a
const S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
const TAB = 9;
const NL = 0xA;
const CR = 0xD;
const SPACE = 0x20;
const BANG = 0x21;
const DQUOTE = 0x22;
const AMP = 0x26;
const SQUOTE = 0x27;
const MINUS = 0x2D;
const FORWARD_SLASH = 0x2F;
const SEMICOLON = 0x3B;
const LESS = 0x3C;
const EQUAL = 0x3D;
const GREATER = 0x3E;
const QUESTION = 0x3F;
const OPEN_BRACKET = 0x5B;
const CLOSE_BRACKET = 0x5D;
const NEL = 0x85;
const LS = 0x2028; // Line Separator
const isQuote = c => c === DQUOTE || c === SQUOTE;
const QUOTES = [DQUOTE, SQUOTE];
const DOCTYPE_TERMINATOR = [...QUOTES, OPEN_BRACKET, GREATER];
const DTD_TERMINATOR = [...QUOTES, LESS, CLOSE_BRACKET];
const XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION, ...S_LIST];
const ATTRIB_VALUE_UNQUOTED_TERMINATOR = [...S_LIST, GREATER, AMP, LESS];
function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail("xml prefix must be bound to ".concat(XML_NAMESPACE, "."));
      }
      break;
    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail("xmlns prefix must be bound to ".concat(XMLNS_NAMESPACE, "."));
      }
      break;
    default:
  }
  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? "the default namespace may not be set to ".concat(uri, ".") : "may not assign a prefix (even \"xmlns\") to the URI ".concat(XMLNS_NAMESPACE, "."));
      break;
    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;
        case "":
          parser.fail("the default namespace may not be set to ".concat(uri, "."));
          break;
        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }
      break;
    default:
  }
}
function nsMappingCheck(parser, mapping) {
  for (const local of Object.keys(mapping)) {
    nsPairCheck(parser, local, mapping[local]);
  }
}
const isNCName = name => NC_NAME_RE.test(name);
const isName = name => NAME_RE.test(name);
const FORBIDDEN_START = 0;
const FORBIDDEN_BRACKET = 1;
const FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */
exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
const EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};
class SaxesParser {
  /**
   * @param opt The parser options.
   */
  constructor(opt) {
    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    const xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;
    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsNS;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribNS;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      const additional = this.opt.additionalNamespaces;
      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsPlain;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribPlain;
    }
    //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //
    this.stateTable = [/* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];
    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */
  get closed() {
    return this._closed;
  }
  _init() {
    var _a;
    this.openWakaBang = "";
    this.text = "";
    this.name = "";
    this.piTarget = "";
    this.entity = "";
    this.q = null;
    this.tags = [];
    this.tag = null;
    this.topNS = null;
    this.chunk = "";
    this.chunkPosition = 0;
    this.i = 0;
    this.prevI = 0;
    this.carriedFromPrevious = undefined;
    this.forbiddenState = FORBIDDEN_START;
    this.attribList = [];
    // The logic is organized so as to minimize the need to check
    // this.opt.fragment while parsing.
    const {
      fragmentOpt
    } = this;
    this.state = fragmentOpt ? S_TEXT : S_BEGIN;
    // We want these to be all true if we are dealing with a fragment.
    this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
    // An XML declaration is intially possible only when parsing whole
    // documents.
    this.xmlDeclPossible = !fragmentOpt;
    this.xmlDeclExpects = ["version"];
    this.entityReturnState = undefined;
    let {
      defaultXMLVersion
    } = this.opt;
    if (defaultXMLVersion === undefined) {
      if (this.opt.forceXMLVersion === true) {
        throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
      }
      defaultXMLVersion = "1.0";
    }
    this.setXMLVersion(defaultXMLVersion);
    this.positionAtNewLine = 0;
    this.doctype = false;
    this._closed = false;
    this.xmlDecl = {
      version: undefined,
      encoding: undefined,
      standalone: undefined
    };
    this.line = 1;
    this.column = 0;
    this.ENTITIES = Object.create(XML_ENTITIES);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  /**
   * The stream position the parser is currently looking at. This field is
   * zero-based.
   *
   * This field is not based on counting Unicode characters but is to be
   * interpreted as a plain index into a JavaScript string.
   */
  get position() {
    return this.chunkPosition + this.i;
  }
  /**
   * The column number of the next character to be read by the parser.  *
   * This field is zero-based. (The first column in a line is 0.)
   *
   * This field reports the index at which the next character would be in the
   * line if the line were represented as a JavaScript string.  Note that this
   * *can* be different to a count based on the number of *Unicode characters*
   * due to how JavaScript handles astral plane characters.
   *
   * See [[column]] for a number that corresponds to a count of Unicode
   * characters.
   */
  get columnIndex() {
    return this.position - this.positionAtNewLine;
  }
  /**
   * Set an event listener on an event. The parser supports one handler per
   * event type. If you try to set an event handler over an existing handler,
   * the old handler is silently overwritten.
   *
   * @param name The event to listen to.
   *
   * @param handler The handler to set.
   */
  on(name, handler) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
  }
  /**
   * Unset an event handler.
   *
   * @parma name The event to stop listening to.
   */
  off(name) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
  }
  /**
   * Make an error object. The error object will have a message that contains
   * the ``fileName`` option passed at the creation of the parser. If position
   * tracking was turned on, it will also have line and column number
   * information.
   *
   * @param message The message describing the error to report.
   *
   * @returns An error object with a properly formatted message.
   */
  makeError(message) {
    var _a;
    let msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
    if (this.trackPosition) {
      if (msg.length > 0) {
        msg += ":";
      }
      msg += "".concat(this.line, ":").concat(this.column);
    }
    if (msg.length > 0) {
      msg += ": ";
    }
    return new Error(msg + message);
  }
  /**
   * Report a parsing error. This method is made public so that client code may
   * check for issues that are outside the scope of this project and can report
   * errors.
   *
   * @param message The error to report.
   *
   * @returns this
   */
  fail(message) {
    const err = this.makeError(message);
    const handler = this.errorHandler;
    if (handler === undefined) {
      throw err;
    } else {
      handler(err);
    }
    return this;
  }
  /**
   * Write a XML data to the parser.
   *
   * @param chunk The XML data to write.
   *
   * @returns this
   */
  write(chunk) {
    if (this.closed) {
      return this.fail("cannot write after close; assign an onready handler.");
    }
    let end = false;
    if (chunk === null) {
      // We cannot return immediately because carriedFromPrevious may need
      // processing.
      end = true;
      chunk = "";
    } else if (typeof chunk === "object") {
      chunk = chunk.toString();
    }
    // We checked if performing a pre-decomposition of the string into an array
    // of single complete characters (``Array.from(chunk)``) would be faster
    // than the current repeated calls to ``charCodeAt``. As of August 2018, it
    // isn't. (There may be Node-specific code that would perform faster than
    // ``Array.from`` but don't want to be dependent on Node.)
    if (this.carriedFromPrevious !== undefined) {
      // The previous chunk had char we must carry over.
      chunk = "".concat(this.carriedFromPrevious).concat(chunk);
      this.carriedFromPrevious = undefined;
    }
    let limit = chunk.length;
    const lastCode = chunk.charCodeAt(limit - 1);
    if (!end && (
    // A trailing CR or surrogate must be carried over to the next
    // chunk.
    lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
      // The chunk ends with a character that must be carried over. We cannot
      // know how to handle it until we get the next chunk or the end of the
      // stream. So save it for later.
      this.carriedFromPrevious = chunk[limit - 1];
      limit--;
      chunk = chunk.slice(0, limit);
    }
    const {
      stateTable
    } = this;
    this.chunk = chunk;
    this.i = 0;
    while (this.i < limit) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      stateTable[this.state].call(this);
    }
    this.chunkPosition += limit;
    return end ? this.end() : this;
  }
  /**
   * Close the current stream. Perform final well-formedness checks and reset
   * the parser tstate.
   *
   * @returns this
   */
  close() {
    return this.write(null);
  }
  /**
   * Get a single code point out of the current chunk. This updates the current
   * position if we do position tracking.
   *
   * This is the algorithm to use for XML 1.0.
   *
   * @returns The character read.
   */
  getCode10() {
    const {
      chunk,
      i
    } = this;
    this.prevI = i;
    // Yes, we do this instead of doing this.i++. Doing it this way, we do not
    // read this.i again, which is a bit faster.
    this.i = i + 1;
    if (i >= chunk.length) {
      return EOC;
    }
    // Using charCodeAt and handling the surrogates ourselves is faster
    // than using codePointAt.
    const code = chunk.charCodeAt(i);
    this.column++;
    if (code < 0xD800) {
      if (code >= SPACE || code === TAB) {
        return code;
      }
      switch (code) {
        case NL:
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL;
        case CR:
          // We may get NaN if we read past the end of the chunk, which is fine.
          if (chunk.charCodeAt(i + 1) === NL) {
            // A \r\n sequence is converted to \n so we have to skip over the
            // next character. We already know it has a size of 1 so ++ is fine
            // here.
            this.i = i + 2;
          }
          // Otherwise, a \r is just converted to \n, so we don't have to skip
          // ahead.
          // In either case, \r becomes \n.
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL_LIKE;
        default:
          // If we get here, then code < SPACE and it is not NL CR or TAB.
          this.fail("disallowed character.");
          return code;
      }
    }
    if (code > 0xDBFF) {
      // This is a specialized version of isChar10 that takes into account
      // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
      // test cases that don't need testing.
      if (!(code >= 0xE000 && code <= 0xFFFD)) {
        this.fail("disallowed character.");
      }
      return code;
    }
    const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
    this.i = i + 2;
    // This is a specialized version of isChar10 that takes into account that in
    // this context necessarily final >= 0x10000.
    if (final > 0x10FFFF) {
      this.fail("disallowed character.");
    }
    return final;
  }
  /**
   * Get a single code point out of the current chunk. This updates the current
   * position if we do position tracking.
   *
   * This is the algorithm to use for XML 1.1.
   *
   * @returns {number} The character read.
   */
  getCode11() {
    const {
      chunk,
      i
    } = this;
    this.prevI = i;
    // Yes, we do this instead of doing this.i++. Doing it this way, we do not
    // read this.i again, which is a bit faster.
    this.i = i + 1;
    if (i >= chunk.length) {
      return EOC;
    }
    // Using charCodeAt and handling the surrogates ourselves is faster
    // than using codePointAt.
    const code = chunk.charCodeAt(i);
    this.column++;
    if (code < 0xD800) {
      if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
        return code;
      }
      switch (code) {
        case NL:
          // 0xA
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL;
        case CR:
          {
            // 0xD
            // We may get NaN if we read past the end of the chunk, which is
            // fine.
            const next = chunk.charCodeAt(i + 1);
            if (next === NL || next === NEL) {
              // A CR NL or CR NEL sequence is converted to NL so we have to skip
              // over the next character. We already know it has a size of 1.
              this.i = i + 2;
            }
            // Otherwise, a CR is just converted to NL, no skip.
          }
        /* yes, fall through */
        case NEL: // 0x85
        case LS:
          // Ox2028
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL_LIKE;
        default:
          this.fail("disallowed character.");
          return code;
      }
    }
    if (code > 0xDBFF) {
      // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
      // does not test cases that don't need testing.
      if (!(code >= 0xE000 && code <= 0xFFFD)) {
        this.fail("disallowed character.");
      }
      return code;
    }
    const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
    this.i = i + 2;
    // This is a specialized version of isCharAndNotRestricted that takes into
    // account that in this context necessarily final >= 0x10000.
    if (final > 0x10FFFF) {
      this.fail("disallowed character.");
    }
    return final;
  }
  /**
   * Like ``getCode`` but with the return value normalized so that ``NL`` is
   * returned for ``NL_LIKE``.
   */
  getCodeNorm() {
    const c = this.getCode();
    return c === NL_LIKE ? NL : c;
  }
  unget() {
    this.i = this.prevI;
    this.column--;
  }
  /**
   * Capture characters into a buffer until encountering one of a set of
   * characters.
   *
   * @param chars An array of codepoints. Encountering a character in the array
   * ends the capture. (``chars`` may safely contain ``NL``.)
   *
   * @return The character code that made the capture end, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  captureTo(chars) {
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCode();
      const isNLLike = c === NL_LIKE;
      const final = isNLLike ? NL : c;
      if (final === EOC || chars.includes(final)) {
        this.text += chunk.slice(start, this.prevI);
        return final;
      }
      if (isNLLike) {
        this.text += "".concat(chunk.slice(start, this.prevI), "\n");
        start = this.i;
      }
    }
  }
  /**
   * Capture characters into a buffer until encountering a character.
   *
   * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
   * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
   *
   * @return ``true`` if we ran into the character. Otherwise, we ran into the
   * end of the current chunk.
   */
  captureToChar(char) {
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let c = this.getCode();
      switch (c) {
        case NL_LIKE:
          this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
          c = NL;
          break;
        case EOC:
          this.text += chunk.slice(start);
          return false;
        default:
      }
      if (c === char) {
        this.text += chunk.slice(start, this.prevI);
        return true;
      }
    }
  }
  /**
   * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
   * this parser.
   *
   * @return The character code that made the test fail, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  captureNameChars() {
    const {
      chunk,
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCode();
      if (c === EOC) {
        this.name += chunk.slice(start);
        return EOC;
      }
      // NL is not a name char so we don't have to test specifically for it.
      if (!isNameChar(c)) {
        this.name += chunk.slice(start, this.prevI);
        return c === NL_LIKE ? NL : c;
      }
    }
  }
  /**
   * Skip white spaces.
   *
   * @return The character that ended the skip, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  skipSpaces() {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCodeNorm();
      if (c === EOC || !isS(c)) {
        return c;
      }
    }
  }
  setXMLVersion(version) {
    this.currentXMLVersion = version;
    /*  eslint-disable @typescript-eslint/unbound-method */
    if (version === "1.0") {
      this.isChar = isChar10;
      this.getCode = this.getCode10;
    } else {
      this.isChar = isChar11;
      this.getCode = this.getCode11;
    }
    /* eslint-enable @typescript-eslint/unbound-method */
  }
  // STATE ENGINE METHODS
  // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
  // to be sure never to come back to this state later.
  sBegin() {
    // We are essentially peeking at the first character of the chunk. Since
    // S_BEGIN can be in effect only when we start working on the first chunk,
    // the index at which we must look is necessarily 0. Note also that the
    // following test does not depend on decoding surrogates.
    // If the initial character is 0xFEFF, ignore it.
    if (this.chunk.charCodeAt(0) === 0xFEFF) {
      this.i++;
      this.column++;
    }
    this.state = S_BEGIN_WHITESPACE;
  }
  sBeginWhitespace() {
    // We need to know whether we've encountered spaces or not because as soon
    // as we run into a space, an XML declaration is no longer possible. Rather
    // than slow down skipSpaces even in places where we don't care whether it
    // skipped anything or not, we check whether prevI is equal to the value of
    // i from before we skip spaces.
    const iBefore = this.i;
    const c = this.skipSpaces();
    if (this.prevI !== iBefore) {
      this.xmlDeclPossible = false;
    }
    switch (c) {
      case LESS:
        this.state = S_OPEN_WAKA;
        // We could naively call closeText but in this state, it is not normal
        // to have text be filled with any data.
        if (this.text.length !== 0) {
          throw new Error("no-empty text at start");
        }
        break;
      case EOC:
        break;
      default:
        this.unget();
        this.state = S_TEXT;
        this.xmlDeclPossible = false;
    }
  }
  sDoctype() {
    var _a;
    const c = this.captureTo(DOCTYPE_TERMINATOR);
    switch (c) {
      case GREATER:
        {
          // eslint-disable-next-line no-unused-expressions
          (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
          this.text = "";
          this.state = S_TEXT;
          this.doctype = true; // just remember that we saw it.
          break;
        }
      case EOC:
        break;
      default:
        this.text += String.fromCodePoint(c);
        if (c === OPEN_BRACKET) {
          this.state = S_DTD;
        } else if (isQuote(c)) {
          this.state = S_DOCTYPE_QUOTE;
          this.q = c;
        }
    }
  }
  sDoctypeQuote() {
    const q = this.q;
    if (this.captureToChar(q)) {
      this.text += String.fromCodePoint(q);
      this.q = null;
      this.state = S_DOCTYPE;
    }
  }
  sDTD() {
    const c = this.captureTo(DTD_TERMINATOR);
    if (c === EOC) {
      return;
    }
    this.text += String.fromCodePoint(c);
    if (c === CLOSE_BRACKET) {
      this.state = S_DOCTYPE;
    } else if (c === LESS) {
      this.state = S_DTD_OPEN_WAKA;
    } else if (isQuote(c)) {
      this.state = S_DTD_QUOTED;
      this.q = c;
    }
  }
  sDTDQuoted() {
    const q = this.q;
    if (this.captureToChar(q)) {
      this.text += String.fromCodePoint(q);
      this.state = S_DTD;
      this.q = null;
    }
  }
  sDTDOpenWaka() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    switch (c) {
      case BANG:
        this.state = S_DTD_OPEN_WAKA_BANG;
        this.openWakaBang = "";
        break;
      case QUESTION:
        this.state = S_DTD_PI;
        break;
      default:
        this.state = S_DTD;
    }
  }
  sDTDOpenWakaBang() {
    const char = String.fromCodePoint(this.getCodeNorm());
    const owb = this.openWakaBang += char;
    this.text += char;
    if (owb !== "-") {
      this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
      this.openWakaBang = "";
    }
  }
  sDTDComment() {
    if (this.captureToChar(MINUS)) {
      this.text += "-";
      this.state = S_DTD_COMMENT_ENDING;
    }
  }
  sDTDCommentEnding() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
  }
  sDTDCommentEnded() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    if (c === GREATER) {
      this.state = S_DTD;
    } else {
      this.fail("malformed comment.");
      // <!-- blah -- bloo --> will be recorded as
      // a comment of " blah -- bloo "
      this.state = S_DTD_COMMENT;
    }
  }
  sDTDPI() {
    if (this.captureToChar(QUESTION)) {
      this.text += "?";
      this.state = S_DTD_PI_ENDING;
    }
  }
  sDTDPIEnding() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    if (c === GREATER) {
      this.state = S_DTD;
    }
  }
  sText() {
    //
    // We did try a version of saxes where the S_TEXT state was split in two
    // states: one for text inside the root element, and one for text
    // outside. This was avoiding having to test this.tags.length to decide
    // what implementation to actually use.
    //
    // Peformance testing on gigabyte-size files did not show any advantage to
    // using the two states solution instead of the current one. Conversely, it
    // made the code a bit more complicated elsewhere. For instance, a comment
    // can appear before the root element so when a comment ended it was
    // necessary to determine whether to return to the S_TEXT state or to the
    // new text-outside-root state.
    //
    if (this.tags.length !== 0) {
      this.handleTextInRoot();
    } else {
      this.handleTextOutsideRoot();
    }
  }
  sEntity() {
    // This is essentially a specialized version of captureToChar(SEMICOLON...)
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    loop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case NL_LIKE:
          this.entity += "".concat(chunk.slice(start, this.prevI), "\n");
          start = this.i;
          break;
        case SEMICOLON:
          {
            const {
              entityReturnState
            } = this;
            const entity = this.entity + chunk.slice(start, this.prevI);
            this.state = entityReturnState;
            let parsed;
            if (entity === "") {
              this.fail("empty entity name.");
              parsed = "&;";
            } else {
              parsed = this.parseEntity(entity);
              this.entity = "";
            }
            if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
              this.text += parsed;
            }
            // eslint-disable-next-line no-labels
            break loop;
          }
        case EOC:
          this.entity += chunk.slice(start);
          // eslint-disable-next-line no-labels
          break loop;
        default:
      }
    }
  }
  sOpenWaka() {
    // Reminder: a state handler is called with at least one character
    // available in the current chunk. So the first call to get code inside of
    // a state handler cannot return ``EOC``. That's why we don't test
    // for it.
    const c = this.getCode();
    // either a /, ?, !, or text is coming next.
    if (isNameStartChar(c)) {
      this.state = S_OPEN_TAG;
      this.unget();
      this.xmlDeclPossible = false;
    } else {
      switch (c) {
        case FORWARD_SLASH:
          this.state = S_CLOSE_TAG;
          this.xmlDeclPossible = false;
          break;
        case BANG:
          this.state = S_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          this.xmlDeclPossible = false;
          break;
        case QUESTION:
          this.state = S_PI_FIRST_CHAR;
          break;
        default:
          this.fail("disallowed character in tag name");
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }
  sOpenWakaBang() {
    this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
    switch (this.openWakaBang) {
      case "[CDATA[":
        if (!this.sawRoot && !this.reportedTextBeforeRoot) {
          this.fail("text data outside of root node.");
          this.reportedTextBeforeRoot = true;
        }
        if (this.closedRoot && !this.reportedTextAfterRoot) {
          this.fail("text data outside of root node.");
          this.reportedTextAfterRoot = true;
        }
        this.state = S_CDATA;
        this.openWakaBang = "";
        break;
      case "--":
        this.state = S_COMMENT;
        this.openWakaBang = "";
        break;
      case "DOCTYPE":
        this.state = S_DOCTYPE;
        if (this.doctype || this.sawRoot) {
          this.fail("inappropriately located doctype declaration.");
        }
        this.openWakaBang = "";
        break;
      default:
        // 7 happens to be the maximum length of the string that can possibly
        // match one of the cases above.
        if (this.openWakaBang.length >= 7) {
          this.fail("incorrect syntax.");
        }
    }
  }
  sComment() {
    if (this.captureToChar(MINUS)) {
      this.state = S_COMMENT_ENDING;
    }
  }
  sCommentEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === MINUS) {
      this.state = S_COMMENT_ENDED;
      // eslint-disable-next-line no-unused-expressions
      (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
      this.text = "";
    } else {
      this.text += "-".concat(String.fromCodePoint(c));
      this.state = S_COMMENT;
    }
  }
  sCommentEnded() {
    const c = this.getCodeNorm();
    if (c !== GREATER) {
      this.fail("malformed comment.");
      // <!-- blah -- bloo --> will be recorded as
      // a comment of " blah -- bloo "
      this.text += "--".concat(String.fromCodePoint(c));
      this.state = S_COMMENT;
    } else {
      this.state = S_TEXT;
    }
  }
  sCData() {
    if (this.captureToChar(CLOSE_BRACKET)) {
      this.state = S_CDATA_ENDING;
    }
  }
  sCDataEnding() {
    const c = this.getCodeNorm();
    if (c === CLOSE_BRACKET) {
      this.state = S_CDATA_ENDING_2;
    } else {
      this.text += "]".concat(String.fromCodePoint(c));
      this.state = S_CDATA;
    }
  }
  sCDataEnding2() {
    var _a;
    const c = this.getCodeNorm();
    switch (c) {
      case GREATER:
        {
          // eslint-disable-next-line no-unused-expressions
          (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
          this.text = "";
          this.state = S_TEXT;
          break;
        }
      case CLOSE_BRACKET:
        this.text += "]";
        break;
      default:
        this.text += "]]".concat(String.fromCodePoint(c));
        this.state = S_CDATA;
    }
  }
  // We need this separate state to check the first character fo the pi target
  // with this.nameStartCheck which allows less characters than this.nameCheck.
  sPIFirstChar() {
    const c = this.getCodeNorm();
    // This is first because in the case where the file is well-formed this is
    // the branch taken. We optimize for well-formedness.
    if (this.nameStartCheck(c)) {
      this.piTarget += String.fromCodePoint(c);
      this.state = S_PI_REST;
    } else if (c === QUESTION || isS(c)) {
      this.fail("processing instruction without a target.");
      this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
    } else {
      this.fail("disallowed character in processing instruction name.");
      this.piTarget += String.fromCodePoint(c);
      this.state = S_PI_REST;
    }
  }
  sPIRest() {
    // Capture characters into a piTarget while ``this.nameCheck`` run on the
    // character read returns true.
    const {
      chunk,
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCodeNorm();
      if (c === EOC) {
        this.piTarget += chunk.slice(start);
        return;
      }
      // NL cannot satisfy this.nameCheck so we don't have to test specifically
      // for it.
      if (!this.nameCheck(c)) {
        this.piTarget += chunk.slice(start, this.prevI);
        const isQuestion = c === QUESTION;
        if (isQuestion || isS(c)) {
          if (this.piTarget === "xml") {
            if (!this.xmlDeclPossible) {
              this.fail("an XML declaration must be at the start of the document.");
            }
            this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
          } else {
            this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
          }
        } else {
          this.fail("disallowed character in processing instruction name.");
          this.piTarget += String.fromCodePoint(c);
        }
        break;
      }
    }
  }
  sPIBody() {
    if (this.text.length === 0) {
      const c = this.getCodeNorm();
      if (c === QUESTION) {
        this.state = S_PI_ENDING;
      } else if (!isS(c)) {
        this.text = String.fromCodePoint(c);
      }
    }
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    else if (this.captureToChar(QUESTION)) {
      this.state = S_PI_ENDING;
    }
  }
  sPIEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === GREATER) {
      const {
        piTarget
      } = this;
      if (piTarget.toLowerCase() === "xml") {
        this.fail("the XML declaration must appear at the start of the document.");
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
        target: piTarget,
        body: this.text
      });
      this.piTarget = this.text = "";
      this.state = S_TEXT;
    } else if (c === QUESTION) {
      // We ran into ?? as part of a processing instruction. We initially took
      // the first ? as a sign that the PI was ending, but it is not. So we have
      // to add it to the body but we take the new ? as a sign that the PI is
      // ending.
      this.text += "?";
    } else {
      this.text += "?".concat(String.fromCodePoint(c));
      this.state = S_PI_BODY;
    }
    this.xmlDeclPossible = false;
  }
  sXMLDeclNameStart() {
    const c = this.skipSpaces();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      // It is valid to go to S_XML_DECL_ENDING from this state.
      this.state = S_XML_DECL_ENDING;
      return;
    }
    if (c !== EOC) {
      this.state = S_XML_DECL_NAME;
      this.name = String.fromCodePoint(c);
    }
  }
  sXMLDeclName() {
    const c = this.captureTo(XML_DECL_NAME_TERMINATOR);
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.name += this.text;
      this.text = "";
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (!(isS(c) || c === EQUAL)) {
      return;
    }
    this.name += this.text;
    this.text = "";
    if (!this.xmlDeclExpects.includes(this.name)) {
      switch (this.name.length) {
        case 0:
          this.fail("did not expect any more name/value pairs.");
          break;
        case 1:
          this.fail("expected the name ".concat(this.xmlDeclExpects[0], "."));
          break;
        default:
          this.fail("expected one of ".concat(this.xmlDeclExpects.join(", ")));
      }
    }
    this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
  }
  sXMLDeclEq() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (isS(c)) {
      return;
    }
    if (c !== EQUAL) {
      this.fail("value required.");
    }
    this.state = S_XML_DECL_VALUE_START;
  }
  sXMLDeclValueStart() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (isS(c)) {
      return;
    }
    if (!isQuote(c)) {
      this.fail("value must be quoted.");
      this.q = SPACE;
    } else {
      this.q = c;
    }
    this.state = S_XML_DECL_VALUE;
  }
  sXMLDeclValue() {
    const c = this.captureTo([this.q, QUESTION]);
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.text = "";
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (c === EOC) {
      return;
    }
    const value = this.text;
    this.text = "";
    switch (this.name) {
      case "version":
        {
          this.xmlDeclExpects = ["encoding", "standalone"];
          const version = value;
          this.xmlDecl.version = version;
          // This is the test specified by XML 1.0 but it is fine for XML 1.1.
          if (!/^1\.[0-9]+$/.test(version)) {
            this.fail("version number must match /^1\\.[0-9]+$/.");
          }
          // When forceXMLVersion is set, the XML declaration is ignored.
          else if (!this.opt.forceXMLVersion) {
            this.setXMLVersion(version);
          }
          break;
        }
      case "encoding":
        if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
          this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
        }
        this.xmlDeclExpects = ["standalone"];
        this.xmlDecl.encoding = value;
        break;
      case "standalone":
        if (value !== "yes" && value !== "no") {
          this.fail("standalone value must match \"yes\" or \"no\".");
        }
        this.xmlDeclExpects = [];
        this.xmlDecl.standalone = value;
        break;
      default:
      // We don't need to raise an error here since we've already raised one
      // when checking what name was expected.
    }
    this.name = "";
    this.state = S_XML_DECL_SEPARATOR;
  }
  sXMLDeclSeparator() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      // It is valid to go to S_XML_DECL_ENDING from this state.
      this.state = S_XML_DECL_ENDING;
      return;
    }
    if (!isS(c)) {
      this.fail("whitespace required.");
      this.unget();
    }
    this.state = S_XML_DECL_NAME_START;
  }
  sXMLDeclEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === GREATER) {
      if (this.piTarget !== "xml") {
        this.fail("processing instructions are not allowed before root.");
      } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
        this.fail("XML declaration must contain a version.");
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
      this.name = "";
      this.piTarget = this.text = "";
      this.state = S_TEXT;
    } else {
      // We got here because the previous character was a ?, but the question
      // mark character is not valid inside any of the XML declaration
      // name/value pairs.
      this.fail("The character ? is disallowed anywhere in XML declarations.");
    }
    this.xmlDeclPossible = false;
  }
  sOpenTag() {
    var _a;
    const c = this.captureNameChars();
    if (c === EOC) {
      return;
    }
    const tag = this.tag = {
      name: this.name,
      attributes: Object.create(null)
    };
    this.name = "";
    if (this.xmlnsOpt) {
      this.topNS = tag.ns = Object.create(null);
    }
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    this.sawRoot = true;
    if (!this.fragmentOpt && this.closedRoot) {
      this.fail("documents may contain only one root.");
    }
    switch (c) {
      case GREATER:
        this.openTag();
        break;
      case FORWARD_SLASH:
        this.state = S_OPEN_TAG_SLASH;
        break;
      default:
        if (!isS(c)) {
          this.fail("disallowed character in tag name.");
        }
        this.state = S_ATTRIB;
    }
  }
  sOpenTagSlash() {
    if (this.getCode() === GREATER) {
      this.openSelfClosingTag();
    } else {
      this.fail("forward-slash in opening tag not followed by >.");
      this.state = S_ATTRIB;
    }
  }
  sAttrib() {
    const c = this.skipSpaces();
    if (c === EOC) {
      return;
    }
    if (isNameStartChar(c)) {
      this.unget();
      this.state = S_ATTRIB_NAME;
    } else if (c === GREATER) {
      this.openTag();
    } else if (c === FORWARD_SLASH) {
      this.state = S_OPEN_TAG_SLASH;
    } else {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribName() {
    const c = this.captureNameChars();
    if (c === EQUAL) {
      this.state = S_ATTRIB_VALUE;
    } else if (isS(c)) {
      this.state = S_ATTRIB_NAME_SAW_WHITE;
    } else if (c === GREATER) {
      this.fail("attribute without value.");
      this.pushAttrib(this.name, this.name);
      this.name = this.text = "";
      this.openTag();
    } else if (c !== EOC) {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribNameSawWhite() {
    const c = this.skipSpaces();
    switch (c) {
      case EOC:
        return;
      case EQUAL:
        this.state = S_ATTRIB_VALUE;
        break;
      default:
        this.fail("attribute without value.");
        // Should we do this???
        // this.tag.attributes[this.name] = "";
        this.text = "";
        this.name = "";
        if (c === GREATER) {
          this.openTag();
        } else if (isNameStartChar(c)) {
          this.unget();
          this.state = S_ATTRIB_NAME;
        } else {
          this.fail("disallowed character in attribute name.");
          this.state = S_ATTRIB;
        }
    }
  }
  sAttribValue() {
    const c = this.getCodeNorm();
    if (isQuote(c)) {
      this.q = c;
      this.state = S_ATTRIB_VALUE_QUOTED;
    } else if (!isS(c)) {
      this.fail("unquoted attribute value.");
      this.state = S_ATTRIB_VALUE_UNQUOTED;
      this.unget();
    }
  }
  sAttribValueQuoted() {
    // We deliberately do not use captureTo here. The specialized code we use
    // here is faster than using captureTo.
    const {
      q,
      chunk
    } = this;
    let {
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case q:
          this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
          this.name = this.text = "";
          this.q = null;
          this.state = S_ATTRIB_VALUE_CLOSED;
          return;
        case AMP:
          this.text += chunk.slice(start, this.prevI);
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
          return;
        case NL:
        case NL_LIKE:
        case TAB:
          this.text += "".concat(chunk.slice(start, this.prevI), " ");
          start = this.i;
          break;
        case LESS:
          this.text += chunk.slice(start, this.prevI);
          this.fail("disallowed character.");
          return;
        case EOC:
          this.text += chunk.slice(start);
          return;
        default:
      }
    }
  }
  sAttribValueClosed() {
    const c = this.getCodeNorm();
    if (isS(c)) {
      this.state = S_ATTRIB;
    } else if (c === GREATER) {
      this.openTag();
    } else if (c === FORWARD_SLASH) {
      this.state = S_OPEN_TAG_SLASH;
    } else if (isNameStartChar(c)) {
      this.fail("no whitespace between attributes.");
      this.unget();
      this.state = S_ATTRIB_NAME;
    } else {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribValueUnquoted() {
    // We don't do anything regarding EOL or space handling for unquoted
    // attributes. We already have failed by the time we get here, and the
    // contract that saxes upholds states that upon failure, it is not safe to
    // rely on the data passed to event handlers (other than
    // ``onerror``). Passing "bad" data is not a problem.
    const c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);
    switch (c) {
      case AMP:
        this.state = S_ENTITY;
        this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
        break;
      case LESS:
        this.fail("disallowed character.");
        break;
      case EOC:
        break;
      default:
        if (this.text.includes("]]>")) {
          this.fail("the string \"]]>\" is disallowed in char data.");
        }
        this.pushAttrib(this.name, this.text);
        this.name = this.text = "";
        if (c === GREATER) {
          this.openTag();
        } else {
          this.state = S_ATTRIB;
        }
    }
  }
  sCloseTag() {
    const c = this.captureNameChars();
    if (c === GREATER) {
      this.closeTag();
    } else if (isS(c)) {
      this.state = S_CLOSE_TAG_SAW_WHITE;
    } else if (c !== EOC) {
      this.fail("disallowed character in closing tag.");
    }
  }
  sCloseTagSawWhite() {
    switch (this.skipSpaces()) {
      case GREATER:
        this.closeTag();
        break;
      case EOC:
        break;
      default:
        this.fail("disallowed character in closing tag.");
    }
  }
  // END OF STATE ENGINE METHODS
  handleTextInRoot() {
    // This is essentially a specialized version of captureTo which is optimized
    // for performing the ]]> check. A previous version of this code, checked
    // ``this.text`` for the presence of ]]>. It simplified the code but was
    // very costly when character data contained a lot of entities to be parsed.
    //
    // Since we are using a specialized loop, we also keep track of the presence
    // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
    //
    let {
      i: start,
      forbiddenState
    } = this;
    const {
      chunk,
      textHandler: handler
    } = this;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    scanLoop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case LESS:
          {
            this.state = S_OPEN_WAKA;
            if (handler !== undefined) {
              const {
                text
              } = this;
              const slice = chunk.slice(start, this.prevI);
              if (text.length !== 0) {
                handler(text + slice);
                this.text = "";
              } else if (slice.length !== 0) {
                handler(slice);
              }
            }
            forbiddenState = FORBIDDEN_START;
            // eslint-disable-next-line no-labels
            break scanLoop;
          }
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_TEXT;
          if (handler !== undefined) {
            this.text += chunk.slice(start, this.prevI);
          }
          forbiddenState = FORBIDDEN_START;
          // eslint-disable-next-line no-labels
          break scanLoop;
        case CLOSE_BRACKET:
          switch (forbiddenState) {
            case FORBIDDEN_START:
              forbiddenState = FORBIDDEN_BRACKET;
              break;
            case FORBIDDEN_BRACKET:
              forbiddenState = FORBIDDEN_BRACKET_BRACKET;
              break;
            case FORBIDDEN_BRACKET_BRACKET:
              break;
            default:
              throw new Error("impossible state");
          }
          break;
        case GREATER:
          if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }
          forbiddenState = FORBIDDEN_START;
          break;
        case NL_LIKE:
          if (handler !== undefined) {
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          }
          start = this.i;
          forbiddenState = FORBIDDEN_START;
          break;
        case EOC:
          if (handler !== undefined) {
            this.text += chunk.slice(start);
          }
          // eslint-disable-next-line no-labels
          break scanLoop;
        default:
          forbiddenState = FORBIDDEN_START;
      }
    }
    this.forbiddenState = forbiddenState;
  }
  handleTextOutsideRoot() {
    // This is essentially a specialized version of captureTo which is optimized
    // for a specialized task. We keep track of the presence of non-space
    // characters in the text since these are errors when appearing outside the
    // document root element.
    let {
      i: start
    } = this;
    const {
      chunk,
      textHandler: handler
    } = this;
    let nonSpace = false;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    outRootLoop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const code = this.getCode();
      switch (code) {
        case LESS:
          {
            this.state = S_OPEN_WAKA;
            if (handler !== undefined) {
              const {
                text
              } = this;
              const slice = chunk.slice(start, this.prevI);
              if (text.length !== 0) {
                handler(text + slice);
                this.text = "";
              } else if (slice.length !== 0) {
                handler(slice);
              }
            }
            // eslint-disable-next-line no-labels
            break outRootLoop;
          }
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_TEXT;
          if (handler !== undefined) {
            this.text += chunk.slice(start, this.prevI);
          }
          nonSpace = true;
          // eslint-disable-next-line no-labels
          break outRootLoop;
        case NL_LIKE:
          if (handler !== undefined) {
            this.text += "".concat(chunk.slice(start, this.prevI), "\n");
          }
          start = this.i;
          break;
        case EOC:
          if (handler !== undefined) {
            this.text += chunk.slice(start);
          }
          // eslint-disable-next-line no-labels
          break outRootLoop;
        default:
          if (!isS(code)) {
            nonSpace = true;
          }
      }
    }
    if (!nonSpace) {
      return;
    }
    // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
    // to avoid reporting errors for every single character that is out of
    // place.
    if (!this.sawRoot && !this.reportedTextBeforeRoot) {
      this.fail("text data outside of root node.");
      this.reportedTextBeforeRoot = true;
    }
    if (this.closedRoot && !this.reportedTextAfterRoot) {
      this.fail("text data outside of root node.");
      this.reportedTextAfterRoot = true;
    }
  }
  pushAttribNS(name, value) {
    var _a;
    const {
      prefix,
      local
    } = this.qname(name);
    const attr = {
      name,
      prefix,
      local,
      value
    };
    this.attribList.push(attr);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    if (prefix === "xmlns") {
      const trimmed = value.trim();
      if (this.currentXMLVersion === "1.0" && trimmed === "") {
        this.fail("invalid attempt to undefine prefix in XML 1.0");
      }
      this.topNS[local] = trimmed;
      nsPairCheck(this, local, trimmed);
    } else if (name === "xmlns") {
      const trimmed = value.trim();
      this.topNS[""] = trimmed;
      nsPairCheck(this, "", trimmed);
    }
  }
  pushAttribPlain(name, value) {
    var _a;
    const attr = {
      name,
      value
    };
    this.attribList.push(attr);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
  }
  /**
   * End parsing. This performs final well-formedness checks and resets the
   * parser to a clean state.
   *
   * @returns this
   */
  end() {
    var _a, _b;
    if (!this.sawRoot) {
      this.fail("document must contain a root element.");
    }
    const {
      tags
    } = this;
    while (tags.length > 0) {
      const tag = tags.pop();
      this.fail("unclosed tag: ".concat(tag.name));
    }
    if (this.state !== S_BEGIN && this.state !== S_TEXT) {
      this.fail("unexpected end.");
    }
    const {
      text
    } = this;
    if (text.length !== 0) {
      // eslint-disable-next-line no-unused-expressions
      (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
      this.text = "";
    }
    this._closed = true;
    // eslint-disable-next-line no-unused-expressions
    (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);
    this._init();
    return this;
  }
  /**
   * Resolve a namespace prefix.
   *
   * @param prefix The prefix to resolve.
   *
   * @returns The namespace URI or ``undefined`` if the prefix is not defined.
   */
  resolve(prefix) {
    var _a, _b;
    let uri = this.topNS[prefix];
    if (uri !== undefined) {
      return uri;
    }
    const {
      tags
    } = this;
    for (let index = tags.length - 1; index >= 0; index--) {
      uri = tags[index].ns[prefix];
      if (uri !== undefined) {
        return uri;
      }
    }
    uri = this.ns[prefix];
    if (uri !== undefined) {
      return uri;
    }
    return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
  }
  /**
   * Parse a qname into its prefix and local name parts.
   *
   * @param name The name to parse
   *
   * @returns
   */
  qname(name) {
    // This is faster than using name.split(":").
    const colon = name.indexOf(":");
    if (colon === -1) {
      return {
        prefix: "",
        local: name
      };
    }
    const local = name.slice(colon + 1);
    const prefix = name.slice(0, colon);
    if (prefix === "" || local === "" || local.includes(":")) {
      this.fail("malformed name: ".concat(name, "."));
    }
    return {
      prefix,
      local
    };
  }
  processAttribsNS() {
    var _a;
    const {
      attribList
    } = this;
    const tag = this.tag;
    {
      // add namespace info to tag
      const {
        prefix,
        local
      } = this.qname(tag.name);
      tag.prefix = prefix;
      tag.local = local;
      const uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
      if (prefix !== "") {
        if (prefix === "xmlns") {
          this.fail("tags may not have \"xmlns\" as prefix.");
        }
        if (uri === "") {
          this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
          tag.uri = prefix;
        }
      }
    }
    if (attribList.length === 0) {
      return;
    }
    const {
      attributes
    } = tag;
    const seen = new Set();
    // Note: do not apply default ns to attributes:
    //   http://www.w3.org/TR/REC-xml-names/#defaulting
    for (const attr of attribList) {
      const {
        name,
        prefix,
        local
      } = attr;
      let uri;
      let eqname;
      if (prefix === "") {
        uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
        eqname = name;
      } else {
        uri = this.resolve(prefix);
        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (uri === undefined) {
          this.fail("unbound namespace prefix: ".concat(JSON.stringify(prefix), "."));
          uri = prefix;
        }
        eqname = "{".concat(uri, "}").concat(local);
      }
      if (seen.has(eqname)) {
        this.fail("duplicate attribute: ".concat(eqname, "."));
      }
      seen.add(eqname);
      attr.uri = uri;
      attributes[name] = attr;
    }
    this.attribList = [];
  }
  processAttribsPlain() {
    const {
      attribList
    } = this;
    // eslint-disable-next-line prefer-destructuring
    const attributes = this.tag.attributes;
    for (const {
      name,
      value
    } of attribList) {
      if (attributes[name] !== undefined) {
        this.fail("duplicate attribute: ".concat(name, "."));
      }
      attributes[name] = value;
    }
    this.attribList = [];
  }
  /**
   * Handle a complete open tag. This parser code calls this once it has seen
   * the whole tag. This method checks for well-formeness and then emits
   * ``onopentag``.
   */
  openTag() {
    var _a;
    this.processAttribs();
    const {
      tags
    } = this;
    const tag = this.tag;
    tag.isSelfClosing = false;
    // There cannot be any pending text here due to the onopentagstart that was
    // necessarily emitted before we get here. So we do not check text.
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    tags.push(tag);
    this.state = S_TEXT;
    this.name = "";
  }
  /**
   * Handle a complete self-closing tag. This parser code calls this once it has
   * seen the whole tag. This method checks for well-formeness and then emits
   * ``onopentag`` and ``onclosetag``.
   */
  openSelfClosingTag() {
    var _a, _b, _c;
    this.processAttribs();
    const {
      tags
    } = this;
    const tag = this.tag;
    tag.isSelfClosing = true;
    // There cannot be any pending text here due to the onopentagstart that was
    // necessarily emitted before we get here. So we do not check text.
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    // eslint-disable-next-line no-unused-expressions
    (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
    const top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
    if (top === null) {
      this.closedRoot = true;
    }
    this.state = S_TEXT;
    this.name = "";
  }
  /**
   * Handle a complete close tag. This parser code calls this once it has seen
   * the whole tag. This method checks for well-formeness and then emits
   * ``onclosetag``.
   */
  closeTag() {
    const {
      tags,
      name
    } = this;
    // Our state after this will be S_TEXT, no matter what, and we can clear
    // tagName now.
    this.state = S_TEXT;
    this.name = "";
    if (name === "") {
      this.fail("weird empty close tag.");
      this.text += "</>";
      return;
    }
    const handler = this.closeTagHandler;
    let l = tags.length;
    while (l-- > 0) {
      const tag = this.tag = tags.pop();
      this.topNS = tag.ns;
      // eslint-disable-next-line no-unused-expressions
      handler === null || handler === void 0 ? void 0 : handler(tag);
      if (tag.name === name) {
        break;
      }
      this.fail("unexpected close tag.");
    }
    if (l === 0) {
      this.closedRoot = true;
    } else if (l < 0) {
      this.fail("unmatched closing tag: ".concat(name, "."));
      this.text += "</".concat(name, ">");
    }
  }
  /**
   * Resolves an entity. Makes any necessary well-formedness checks.
   *
   * @param entity The entity to resolve.
   *
   * @returns The parsed entity.
   */
  parseEntity(entity) {
    // startsWith would be significantly slower for this test.
    // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    if (entity[0] !== "#") {
      const defined = this.ENTITIES[entity];
      if (defined !== undefined) {
        return defined;
      }
      this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
      return "&".concat(entity, ";");
    }
    let num = NaN;
    if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
      num = parseInt(entity.slice(2), 16);
    } else if (/^#[0-9]+$/.test(entity)) {
      num = parseInt(entity.slice(1), 10);
    }
    // The character reference is required to match the CHAR production.
    if (!this.isChar(num)) {
      this.fail("malformed character entity.");
      return "&".concat(entity, ";");
    }
    return String.fromCodePoint(num);
  }
}
exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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